export enum OrderCalculationToken {
  CustomQuoteCreditCardFee = 'customQuoteCreditCardFee',
  CustomQuoteCreditCardFeePercent = 'customQuoteCreditCardFeePercent',
  CreditCardFee = 'creditCardFee',
  DeliveryPrice = 'deliveryPrice',
  BuildingPrice = 'buildingPrice',
  StructurePrice = 'structurePrice',
  LineItemsSubtotal = 'lineItemsSubtotal',
  PercentOfBuildingItems = 'percentOfBuildingItems',
  PercentOfStructureItems = 'percentOfStructureItems',
  TaxableItemsForPercentOfSubtotalCalc = 'taxableItemsForPercentOfSubtotalCalc',
  PercentOfSubtotalItems = 'percentOfSubtotalItems',
  TaxableItems = 'taxableItems',
  TotalTax = 'totalTax',
  TaxPercentage = 'taxPercentage',
  TotalForPercentOfTotalCalc = 'totalForPercentOfTotalCalc',
  PercentOfTotalItems = 'percentOfTotalItems',
  Subtotal = 'subtotal',
  SubtotalWithoutCustomItems = 'subtotalWithoutCustomItems',
  NonTaxableItems = 'nonTaxableItems',
  SubtotalExcludedFromDeposit = 'subtotalExcludedFromDeposit',
  TotalExcludedFromDeposit = 'totalExcludedFromDeposit',
  Total = 'total',
  TotalCustomDiscounts = 'totalCustomDiscounts',
  TotalCustomExpenses = 'totalCustomExpenses',
  TotalWithCreditCardFee = 'totalWithCreditCardFee',
  DepositAmount = 'depositAmount',
  DepositPercentage = 'depositPercentage',
  StandardDepositPercentage = 'standardDepositPercentage',
  DepositDiscount = 'depositDiscount',
  DepositDueNow = 'depositDueNow',
  DepositDueNowWithCreditCardFee = 'depositDueNowWithCreditCardFee',
  DeliveryFeeToPrintQuote = 'deliveryFeeToPrintQuote',
  RemainingDueForPercentOfRemainingDueCalc = 'remainingDueForPercentOfRemainingDueCalc',
  PercentOfRemainingDueItems = 'percentOfRemainingDueItems',
  ProcessingFee = 'processingFee',
  RemainingDue = 'remainingDue',
  RemainingDueWithCustomQuoteCreditCardFee = 'remainingDueWithCustomQuoteCreditCardFee',
  ScheduleDeposit = 'scheduleDeposit',
  FinalBalance = 'finalBalance',
  Surcharge = 'surcharge',
  SurchargeItems = 'surchargeItems',
  SurchargeSubtotal = 'surchargeSubtotal',
  TaxableSurcharge = 'taxableSurcharge',
  NonTaxableSurcharge = 'nonTaxableSurcharge',
}
